import store from '@/store'
import { computed, onUnmounted, watch, Ref } from '@vue/composition-api'

const useCurrentTeamEvents = (enableSubscription: Ref<boolean>, includeCompleted?: boolean) => {
  const activeTeam = computed(() => store.state.team.activeTeam)
  const activeScheduledEvents = computed(() => store.state.events.events)
  const completedEvents = computed(() => includeCompleted ? store.state.events.completedEvents : [])

  watch(activeTeam, async (newTeamId, oldTeamId) => {
    if (enableSubscription?.value === false) return
    if (newTeamId === oldTeamId) return
    if (oldTeamId !== undefined && oldTeamId !== '') {
      await store.dispatch.events.unsubscribeEvents()
      if (includeCompleted) await store.dispatch.events.unsubscribeCompletedEvent()
    }
    if (newTeamId !== '') {
      await store.dispatch.events.subscribeEvents(newTeamId)
      if (includeCompleted) await store.dispatch.events.subscribeCompletedEvent(newTeamId)
    }
  }, { immediate: true })

  watch(enableSubscription, async (newVal, oldVal) => {
    if (!newVal && oldVal) {
      await store.dispatch.events.unsubscribeEvents()
      if (includeCompleted) await store.dispatch.events.unsubscribeCompletedEvent()
    }
    if (newVal && !oldVal) {
      await store.dispatch.events.subscribeEvents(activeTeam.value)
      if (includeCompleted) await store.dispatch.events.subscribeCompletedEvent(activeTeam.value)
    }
  })

  onUnmounted(async () => {
    if (activeTeam.value !== '' && enableSubscription.value === true) {
      await store.dispatch.events.unsubscribeEvents()
      if (includeCompleted) await store.dispatch.events.unsubscribeCompletedEvent()
    }
  })

  return {
    activeScheduledEvents,
    completedEvents
  }
}

export default useCurrentTeamEvents
